import { render, staticRenderFns } from "./new-payment-method-form.vue?vue&type=template&id=6cc4e0d2&"
import script from "./new-payment-method-form.vue?vue&type=script&lang=js&"
export * from "./new-payment-method-form.vue?vue&type=script&lang=js&"
import style0 from "./new-payment-method-form.vue?vue&type=style&index=0&id=6cc4e0d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports